import Script from 'next/script';
import React from 'react';
import {CITY_CODE_KEY_CLIENT} from 'modules/locations/constants';
import {CookieService} from 'core/services/CookieService';
import {NEXT_PUBLIC_GF_SECTION_ID} from 'core/helpers/env';

export type TGravityPageType = 'HOMEPAGE' | 'SEARCH' | 'PRODUCT' | 'OTHER';

const cookiesService = CookieService.getInstance();

interface IGFScriptProps {
    type?: TGravityPageType;
    data?: any[];
    lng?: string;
}

export const GFScript = (props: IGFScriptProps) => {
    const cityCode = cookiesService.get(CITY_CODE_KEY_CLIENT);
    const {type = 'OTHER', data = [], lng = cityCode ?? 'MSK'} = props;

    const pageContext = JSON.stringify({type, data, lng});

    return (
        <Script id={'StellarlabsProductPageScript'} strategy={'afterInteractive'}>
            {`
                      window.GF = window.GF || {};
                      
                      try {
                        GF.API = () => {};
                      } catch(e) {}
                      
                      try {
                        GF.section = "${NEXT_PUBLIC_GF_SECTION_ID}";
                      } catch(e) {}
                      
                      try {
                        GF.pageContext = ${pageContext};
                      } catch(e) {}

                `}
        </Script>
    );
};
